var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header header-85"},[_c('div',{staticClass:"header-title"},[_vm._t("title")],2),_c('div',{staticClass:"header-right"},[_vm._t("right-panel"),_c('avatar',{ref:"avatar"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }